import fallbackLanuageStrings from './fallbackData/languageStrings.json';
import Logger, {LOG_LEVELS} from './logger';
const log = new Logger('LANGUAGE_CLIENT', LOG_LEVELS.DEBUG);
import fetch from '../utils/fetch-wrapper';
import getClientConfig from './getClientConfig';

export const DEFAULT_LANGUAGE_STRINGS = fallbackLanuageStrings;


export default {
  getLanguageStrings(language) {
    const { vrRestApiHost } = getClientConfig();
    const url = `${vrRestApiHost}/bffapi/v1/language/${language}`;

    log.debug('getLanguageStrings: language: %s, host: ', language, vrRestApiHost);
    return fetch(url, {
      method: 'GET',
      mode: 'cors',
      cache: 'no-cache'
    })
      .then((response) => {
        return response.status === 204 ? DEFAULT_LANGUAGE_STRINGS : response.json();
      })
      .then((json) => {
        log.debug('getLanguageStrings: success: ', json);
        return json;
      })
      .catch((error) => {
        log.debug('getLanguageStrings: error: ', error);
        return DEFAULT_LANGUAGE_STRINGS;
      });
  },
}